import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, ReturnTimeZone } from '../../helpers';
import moment from 'moment-timezone';
import WrongModal from './WrongModal/WrongModal';
import SuccessModal from './SuccessModal/SuccessModal';
import en from './locales/en.json';
import fr from './locales/fr.json';
//import { ScanSettings, Barcode } from "scandit-sdk";
import * as ScanditSDK from "scandit-sdk";
import BarcodePicker from "./BarcodePicker/BarcodePicker";

import './Checkin.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Checkin extends Component {
    constructor(props){
        super(props);
        this.state = {
            event_id: undefined,
            event_date_id: undefined,
            delay: 300,
            result: 'No result',
            isValidQR: undefined,
            isModalOpen: false,
            isModalSuccessOpen: false,
            seatName: undefined,
            ticketId: undefined,
            stopScanning: false,
            scannedTickets: [],
            event: {
                venue: {
                    timezone: 'EST',
                }
            },
        }
    }

    handleScan = (ticketId) => {
        if (ticketId && !this.state.stopScanning) {
            this.setState({ 
                ticketId:ticketId,
                stopScanning: true,
            });
            const doCheckin = async () => {
                try {
                    const checkinResponse = await getCheckin(ticketId, this.state.event_date_id);
                    console.log('checkinResponse: ', checkinResponse);
                        
                    if(checkinResponse.data.error){
                        let scannedTickets = this.state.scannedTickets;
                        let newScannedTicket = {};
                        newScannedTicket.date = '';
                        newScannedTicket.ticketId = ticketId;
                        newScannedTicket.reason = checkinResponse.data.error.code;
                        scannedTickets.unshift(newScannedTicket);
                        const wrongSound = new Audio('/audio/wrong.mp3');
                        wrongSound.play();
                        this.setState({
                            scannedTickets,
                            isValidQR: false,
                            isModalOpen: true,
                            //stopScanning: false,
                        });
                    } else {
                        if(checkinResponse.data.is_valid) {
                            let scannedTickets = this.state.scannedTickets;
                            let newScannedTicket = checkinResponse.data;
                            newScannedTicket.ticketId = ticketId;
                            newScannedTicket.reason = `${checkinResponse.data.customer.first_name} ${checkinResponse.data.customer.last_name}`;
                            scannedTickets.unshift(newScannedTicket);
                            const successSound = new Audio('/audio/success.mp3');
                            successSound.play();
                            this.setState(
                                {
                                    scannedTickets,
                                    isValidQR: true,
                                    isModalSuccessOpen: true,
                                    isModalOpen: false,
                                    seatName: checkinResponse.data.full_seat_name,
                                },
                                () => {
                                    /* setTimeout(() => {
                                        this.setState({
                                            isValidQR: undefined,
                                            stopScanning: false,
                                        });
                                    }, 10000); */
                                }
                            );
                        } else {
                            let scannedTickets = this.state.scannedTickets;
                            let newScannedTicket = checkinResponse.data;
                            newScannedTicket.ticketId = ticketId;
                            scannedTickets.unshift(newScannedTicket);
                            const wrongSound = new Audio('/audio/wrong.mp3');
                            wrongSound.play();
                            this.setState({
                                scannedTickets,
                                isValidQR: false,
                                isModalOpen: true,
                                //stopScanning: false,
                            });
                        }
                    }
                } catch (error) {
                    console.log('error', error);
                    const wrongSound = new Audio('/audio/wrong.mp3');
                    wrongSound.play();
                    this.setState({
                        isValidQR: false,
                        isModalOpen: true,
                        //stopScanning: false,
                    });
                }
            };

            async function getCheckin(ticket_id, event_date_id) {
                return await ApiRequest('/box-office/checkin', {
                    method: 'POST',
                    data: {
                        ticket_id: parseInt(ticket_id, 0),
                        event_date_id: event_date_id
                    }
                });
            }
            doCheckin();
        }
    }

    toggleModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            stopScanning: !this.state.isModalOpen,
        });
    }

    toggleSuccessModal = () => {
        this.setState({
            isModalSuccessOpen: !this.state.isModalSuccessOpen,
            stopScanning: !this.state.isModalSuccessOpen,
        });
    }

    renderScannedTickets = () => {
        let timezone = ReturnTimeZone(this.state.event.venue.timezone || 'EST');
        if(this.state.scannedTickets.length > 0) {
            return (
                <div className="showtix-checkin-tickets">
                    <h2>{strings.scannedTickets}</h2>
                    <table className="showtix-table showtix-table__striped">
                        <thead>
                            <tr>
                                <th>{strings.ticketId}</th>
                                <th>{strings.checkedInDate}</th>
                                <th>{strings.note}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.scannedTickets.map((ticket) => {
                                return (
                                    <tr className={ticket.is_valid ? '' : 'is-wrong'}>
                                        <td>{ticket.ticketId}</td>
                                        <td>{moment.tz(ticket.checked_in, timezone).format('ddd, MMM Do YYYY @ h:mm a')}</td>
                                        <td>{ticket.reason ? ticket.reason.replace('-', ' ') : ''}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    
                </div>    
            );
        } else {
            return null;
        }
    };

    checkoutTicket = () => {
        this.toggleModal();
        console.log('checkout ticket ' + this.state.ticketId);
        const doCheckout = async () => {
            try {
                const checkoutResponse = await getCheckout(this.state.ticketId, this.state.event_date_id);
                console.log('checkoutResponse: ', checkoutResponse);
                if (checkoutResponse.data.success) {
                    let scannedTickets = this.state.scannedTickets;
                    let newScannedTicket = {};
                    newScannedTicket.ticketId = this.state.ticketId;
                    newScannedTicket.reason = 'Checked out';
                    newScannedTicket.is_valid = true;
                    newScannedTicket.checked_in = new Date();
                    scannedTickets.unshift(newScannedTicket);
                    this.setState({
                        scannedTickets,
                    });
                }
            } catch (error) {
                
            }
        };

        async function getCheckout(ticket_id, event_date_id) {
            return await ApiRequest('/box-office/checkin/reverse', {
                method: 'POST',
                data: {
                    ticket_id: parseInt(ticket_id, 0),
                    event_date_id: event_date_id
                }
            });
        }
        doCheckout();

    }

    componentDidMount() {
        this.setState({ 
            event_id: parseInt(this.props.match.params.eventId, 0),
            event_date_id: parseInt(this.props.match.params.eventDateId, 0)
        }, () => {
            this.getEventInfo();
        });
    }

    getEventInfo = () => {
        const getInfo = async () => {
            try {
                const getEventInfoResponse = await getEventInfos(this.state.event_id);
                console.log('getEventInfoResponse: ', getEventInfoResponse);
                    
                if(getEventInfoResponse.data.event){
                    this.setState({
                        event: getEventInfoResponse.data.event,
                    });
                }
            } catch (error) {
                
            }
        };

        async function getEventInfos(eventId) {
            return await ApiRequest(`/events/public/${eventId}`, {
                method: 'GET'
            });
        }
        getInfo();
    }

    render() {
        const scanSettings = new ScanditSDK.ScanSettings({
            enabledSymbologies: [ScanditSDK.Barcode.Symbology.QR],
            codeDuplicateFilter: 1000, // Minimum delay between duplicate results
        });
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h1>{strings.title}</h1>
                        {this.state.seatName &&
                            <p>Last Scan: {this.state.seatName}</p>
                        }
                        {this.state.isValidQR &&
                            <div className="showtix-checkin-valid">Approved</div>
                        }
                        <p style={{'display':'none'}}>{this.state.result}</p>
                        <WrongModal
                            isModalOpen={this.state.isModalOpen}
                            toggleModal={this.toggleModal}
                            checkoutTicket={this.checkoutTicket}
                        />
                        <SuccessModal
                            isModalSuccessOpen={this.state.isModalSuccessOpen}
                            toggleSuccessModal={this.toggleSuccessModal}
                        />
                        <BarcodePicker
                            pauseScanning={this.state.stopScanning}
                            playSoundOnScan={true}
                            vibrateOnScan={true}
                            scanSettings={scanSettings}
                            onScan={scanResult => {
                                console.log('scanning')
                                const ticketId = scanResult.barcodes.reduce(function(barcode) {
                                    return barcode.data;
                                });
                                if(ticketId) {
                                    this.handleScan(ticketId.data);
                                }
                            }}
                            onError={error => {
                                console.error(error.message);
                            }}
                        />
                        {this.renderScannedTickets()}
                    </div>
                </div>
            </div> 
        )
    }
}

Checkin.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }).isRequired,
    }).isRequired
}

export default Checkin;


// WEBPACK FOOTER //
// ./src/components/Checkin/Checkin.js